"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneySanitizer = void 0;
var MoneySanitizer = /** @class */ (function () {
    function MoneySanitizer() {
    }
    MoneySanitizer.prototype.format = function (value) {
        if ('' === value || value === undefined) {
            return '';
        }
        return (Math.round(parseFloat(value) * 100) / 100).toString().replace(/\./g, ',');
    };
    MoneySanitizer.prototype.sanitize = function (value) {
        var nValue = value.replace(/[^0-9,.]/g, '').replace(/,/g, '.');
        if ('' === nValue) {
            return 0;
        }
        return parseFloat(nValue);
    };
    MoneySanitizer.prototype.blockUnallowedCharacters = function (value) {
        var found = false;
        return value.replace(/[^0-9]/g, function (c) {
            if (!found && (c === ',' || c === '.')) {
                found = true;
                return c;
            }
            return '';
        });
    };
    return MoneySanitizer;
}());
exports.MoneySanitizer = MoneySanitizer;
//# sourceMappingURL=MoneySanitizer.js.map